import { render } from "./Cor.vue?vue&type=template&id=c12d3df4&scoped=true"
import script from "./Cor.vue?vue&type=script&lang=js"
export * from "./Cor.vue?vue&type=script&lang=js"

import "./Cor.vue?vue&type=style&index=0&id=c12d3df4&scoped=true&lang=css"

import exportComponent from "E:\\项目\\5.0版本的老界面\\5.0版本的老界面\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c12d3df4"]])

export default __exports__